// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5631":"caa44915","7777":"a76b3770"}[chunkId] + ".chunk.css";
};